import { render, staticRenderFns } from "./CallWeekdaySelector.vue?vue&type=template&id=528c3f4f&scoped=true"
import script from "./CallWeekdaySelector.vue?vue&type=script&lang=js"
export * from "./CallWeekdaySelector.vue?vue&type=script&lang=js"
import style0 from "./CallWeekdaySelector.vue?vue&type=style&index=0&id=528c3f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c3f4f",
  null
  
)

export default component.exports